/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ReactSelect, { Props, SingleValue } from 'react-select';
import isEmpty from 'lodash.isempty';
import { MultiselectOption } from '../../../types/multiselect';

type SelectProps<T = unknown> = Omit<Props<MultiselectOption<T>, false>, 'options' | 'isMulti' | 'onChange' | 'value'> & {
  options: MultiselectOption<T>[];
  onChange?: (selectedOption: MultiselectOption<T> | null) => void;
  value?: MultiselectOption<T> | null;
};

function Select<T = unknown>({
  options, onChange, value, ...props
}: SelectProps<T>) {
  const handleChange = (
    selected: SingleValue<MultiselectOption<T>>,
  ) => {
    if (onChange) {
      onChange(selected);
    }
  };

  const selectValue = isEmpty(value) ? null : value;

  return (
    <ReactSelect<MultiselectOption<T>, false>
      options={options}
      isMulti={false}
      value={selectValue}
      onChange={handleChange}
      classNamePrefix="react-select"
      className="react-select-container"
      components={{
        IndicatorSeparator: null,
      }}
      {...props}
    />
  );
}

export { Select };
